/**
 * 混合引入IOS避审核机制
 */
import device from '@/tools/device'
import api from '@/tools/api-tools'
const IOSAvoidReviewMixins = {
  methods: {
    async $_IOSAvoidReviewMixins_isAvoidReview () {
      if (device.ios && window.localStorage && window.localStorage.getItem('version')) {
        const version = await getReleaseVersion()
        return window.localStorage.getItem('version').toString() >= version.toString()
      }
      return false
    }
  }
}

function getReleaseVersion () {
  return api.get(`http://cloud.fe.laoban100.com/cloud/5a8e6af24710cdd4b0399201/ios/version/beforeRelease`).then(res => {
    return res.data.version || ''
  })
}

export default IOSAvoidReviewMixins



// WEBPACK FOOTER //
// ./src/mixins/ios-avoid-review.js